import { render, staticRenderFns } from "./AttachImage.vue?vue&type=template&id=32346d9b&"
import script from "./AttachImage.vue?vue&type=script&lang=js&"
export * from "./AttachImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Ramon/PROYECTOS/JuanGabriel_POS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32346d9b')) {
      api.createRecord('32346d9b', component.options)
    } else {
      api.reload('32346d9b', component.options)
    }
    module.hot.accept("./AttachImage.vue?vue&type=template&id=32346d9b&", function () {
      api.rerender('32346d9b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/Components/admin/AttachImage.vue"
export default component.exports